export default __webpack_public_path__ + "static/media/1.fb94b22a.png";